import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=37b2dd11&scoped=true&"
import script from "./ProductModal.vue?vue&type=script&lang=js&"
export * from "./ProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductModal.vue?vue&type=style&index=0&id=37b2dd11&prod&lang=css&"
import style1 from "./ProductModal.vue?vue&type=style&index=1&id=37b2dd11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2dd11",
  null
  
)

export default component.exports